const formatCurrency = (amount: any) => {
  if (amount == undefined || amount == null) {
    return "";
  }

  const normalizedAmount = typeof amount === "string" ? amount.trim() : amount;

  if (normalizedAmount === "" || normalizedAmount === "NaN") {
    return "";
  }

  const numericAmount = Number(normalizedAmount);

  if (!Number.isFinite(numericAmount)) {
    return "";
  }

  if (numericAmount === 0) {
    return "$0.00";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(numericAmount);
};

export default formatCurrency;
